/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Requestnewlink2Inputs */

const zh_auth_requestnewlink2 = /** @type {(inputs: Auth_Requestnewlink2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重新申请链接`)
};

const en_auth_requestnewlink2 = /** @type {(inputs: Auth_Requestnewlink2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request new link`)
};

const es_auth_requestnewlink2 = /** @type {(inputs: Auth_Requestnewlink2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solicitar nuevo enlace`)
};

/**
* | output |
* | --- |
* | "Request new link" |
*
* @param {Auth_Requestnewlink2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_requestnewlink2 = /** @type {((inputs?: Auth_Requestnewlink2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Requestnewlink2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_requestnewlink2(inputs)
	if (locale === "en") return en_auth_requestnewlink2(inputs)
	return es_auth_requestnewlink2(inputs)
});
export { auth_requestnewlink2 as "auth_requestNewLink" }